import React, { useState } from "react";
import { arrayOf, shape, string, func, object } from "prop-types";
import { Link } from "react-router-dom";
import ReadingStatus from "../ReadingListDownload/reading_status";
import * as style from "./styles.module.scss";
import OnlineForms from "../OnlineForms";
import ReadingList from "../ReadingList/index";

const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

const ReflexAllenOnboarding = ({
  readingList,
  markDocumentRead,
  reflexAllenOnboarding,
  getPdf,
  reflexAllenForms,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);

  const isInductionFormComplete =
    reflexAllenOnboarding &&
    reflexAllenOnboarding.inductionForm &&
    reflexAllenOnboarding.inductionForm.uncheckedItems &&
    reflexAllenOnboarding.inductionForm.uncheckedItems.length === 0 &&
    reflexAllenOnboarding.inductionForm.checkedItems.length !== 0;
  const readDocuments =
    (reflexAllenOnboarding && reflexAllenOnboarding.readDocuments) || [];
  const readingListWithStatus = readingList
    .map((download) => ({
      ...download,
      status: readDocuments.includes(filenameFromUrl(download.link))
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
    }))
    .sort((a, b) => a.status - b.status);

  return (
    <div className="container py-2">
      <h2>Reflex & Allen Onboarding</h2>
      <div className={`row w-100 m-0 d-flex justify-content-between`}>
        <ReadingList
          readingListWithStatus={readingListWithStatus}
          currentlyReading={currentlyReading}
          setCurrentlyReading={setCurrentlyReading}
          markDocumentRead={markDocumentRead}
        />
        <div className={style.readingList__wrapper}>
          <div
            className={`${style.onlineForms__wrapper} rounded shadow-sm bg-white`}
          >
            <div className={`p-1 ${style.readingList__docs}`}>
              <h5>Documents to Complete</h5>
              <p>
                You are required to complete and submit each of these forms
                before you start work. Please ensure all fields that are marked
                as mandatory are completed to the best of your knowledge. If you
                have any queries about the forms, please speak to your line
                manager.
              </p>
            </div>
            <OnlineForms
              getPdf={getPdf}
              reflexAllenForms={reflexAllenForms}
              reflexAllenOnboarding={reflexAllenOnboarding}
            />
          </div>{" "}
          <div
            className={`${style.readingList__wrapper} rounded w-100 bg-white my-1`}
          >
            <div className={`${style.onlineForms__wrapper} shadow-sm`}>
              <div className={`p-1 ${style.readingList__docs}`}>
                <h5>Induction Checklist</h5>
                <p>
                  You are required to tick off each item on the checklist once
                  you have been informed about it. This should be able to be
                  fully completed by the end of your first day. If you have any
                  queries about the checklist, please speak to your line
                  manager.
                </p>
              </div>
              <div className={`${style.inductionShortcut__wrapper}`}>
                <div className={`${style.inductionShortcut__mobile_row}`}>
                  <div
                    className={`${style.inductionShortcut__status} ${
                      isInductionFormComplete
                        ? style.inductionShortcut__done
                        : style.inductionShortcut__todo
                    }`}
                  >
                    {isInductionFormComplete ? "Done" : "To do"}
                  </div>
                  <span
                    className={`${style.inductionShortcut__title} d-flex align-items-center`}
                  >
                    Induction Checklist
                  </span>
                </div>
                {isInductionFormComplete ? (
                  <Link
                    to={"/profile/edit/onboarding/induction-programme"}
                    className={`${style.inductionShortcut__button} ${style.inductionShortcut__download} btn btn-md btn-outline`}
                  >
                    View Details
                  </Link>
                ) : (
                  <Link
                    className={`${style.inductionShortcut__button} ${style.inductionShortcut__download} btn btn-md btn-outline`}
                    to={"/profile/edit/onboarding/induction-programme"}
                  >
                    Complete
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex justify-content-end mt-4">
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

ReflexAllenOnboarding.propTypes = {
  markDocumentRead: func.isRequired,
  reflexAllenOnboarding: object,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  reflexAllenForms: object,
  getPdf: func,
};

export default ReflexAllenOnboarding;
